import '../sass/citrus-woocommerce-product-gallery.scss';

(() => {
    const $citrusWoocommerceProductGalleries = document.querySelectorAll('.citrus-woocommerce-product-gallery');

    if (!$citrusWoocommerceProductGalleries) return;

    $citrusWoocommerceProductGalleries.forEach($citrusWoocommerceProductGallery => {
        const $carousel = $citrusWoocommerceProductGallery.querySelector('.citrus-woocommerce-product-gallery__carousel');
        const $carouselNavBtns = $citrusWoocommerceProductGallery.querySelectorAll('.citrus-woocommerce-product-gallery__thumbnail-btn');

        const initCarousel = () => {
            if (!$carousel) return;

            const swiperScript = document.querySelector('#citrus-theme-swiper-js');

            if (!swiperScript) return;

            swiperScript.addEventListener('load', () => {
                const carousel = new Swiper($carousel, {
                    keyboard: {
                        enabled: true,
                    },
                    loop: true,
                    autoHeight: true,
                    effect: 'fade',
                    crossFade: true,
                });

                carousel.on('slideChange', swiper => {
                    if (!$carouselNavBtns) return;
                    
                    $carouselNavBtns.forEach(($carouselNavBtn, index) => {
                        if (index !== swiper.realIndex) {
                            $carouselNavBtn.classList.remove('citrus-woocommerce-product-gallery__thumbnail-btn--active');

                            return;
                        }

                        $carouselNavBtn.classList.add('citrus-woocommerce-product-gallery__thumbnail-btn--active');
                    });
                });

                if ($carouselNavBtns) {
                    $carouselNavBtns.forEach($carouselNavBtn => {
                        $carouselNavBtn.addEventListener('click', () => {
                            const $activeCarouselNavBtn = $citrusWoocommerceProductGallery.querySelector('.citrus-woocommerce-product-gallery__thumbnail-btn--active');

                            const { index } = $carouselNavBtn.dataset;

                            $activeCarouselNavBtn.classList.remove('citrus-woocommerce-product-gallery__thumbnail-btn--active');
                            $carouselNavBtn.classList.add('citrus-woocommerce-product-gallery__thumbnail-btn--active');

                            carousel.slideTo(index);
                        });
                    });
                }
            });
        };

        initCarousel();
    });
})();
